// Utilities
import { createSimpleFunctional } from '@/util'

export const VCardTitle = createSimpleFunctional('v-card-title')

export type VCardTitle = InstanceType<typeof VCardTitle>
